export default __webpack_public_path__ + "static/media/dinner3.336624e4.png";